<template>
  <div class="menubg header-container">
    <div class="header-mff">
      <img src="../assets/img/MFF.jpg" />
      <img src="../assets/img/MFF2.png" class="second-img" />
    </div>
    <div class="header-navigation">
      <b-navbar toggleable="xl" type="dark">
        <b-navbar-brand v-on:click="handleHomeNav" class="navbar-brand d-hide header-logo">
          <div class="navbar-brand-text">
            <b-img src="../assets/img/logo/vekonylogo_vali_horisontal.svg" style="width: 150px;" />
          </div>
        </b-navbar-brand>

        <b-navbar-nav>
          <b-navbar-toggle target="nav-collapse">
            <span class="icon-bar top-bar"></span>
            <span class="icon-bar middle-bar"></span>
            <span class="icon-bar bottom-bar"></span>
          </b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item to="/fund-map">Forrástérkép</b-nav-item>

              <b-nav-item to="/news">Hírek</b-nav-item>
              <b-nav-item to="/knowledgebase">Fogalomtár</b-nav-item>

              <b-nav-item to="/favourites" v-show="isAuthenticated && window.width < 1200">Kedvencek</b-nav-item>
              <b-nav-item to="/company-offers-private" v-show="isAuthenticated">Lehetőségeim</b-nav-item>
              <b-nav-item @click="goToVoszport">VOSZPort</b-nav-item>
              <b-nav-item to="/profile" v-show="isAuthenticated && window.width < 1200">Profilom</b-nav-item>

              <b-nav-item
                to="/contents"
                v-show="isAuthenticated && userHaveReadPermission && window.width < 1200"
                v-bind:class="{ whiteMenubg: whiteNav }"
                >Admin</b-nav-item
              >
              <b-nav-item to="/register" v-show="!isAuthenticated">Regisztráció</b-nav-item>
              <b-nav-item v-on:click="showLoginModal" v-show="!isAuthenticated">Bejelentkezés</b-nav-item>
              <div class="d-block d-lg-none">
                <b-nav-item to="/impressum">Impresszum</b-nav-item>

                <b-nav-item download target="_blank" href="https://vali.hu/static/felhasznalasi_feltetelek.pdf">
                  Felhasználási feltételek
                </b-nav-item>
                <b-nav-item download target="_blank" href="https://vali.hu/static/adatkezelesi_tajekoztato.pdf">
                  Adatvédelem
                </b-nav-item>
                <b-nav-item to="/contact">Kapcsolat</b-nav-item>
              </div>
              <b-nav-item v-on:click="handleLogout" v-show="isAuthenticated && window.width < 1200"
                >Kijelentkezés</b-nav-item
              >
              <b-row
                v-show="window.width > 1199"
                v-if="isAuthenticated"
                class="profile-menu-container"
                @click="toggleOpen"
                ref="button"
              >
                <div class="profile-circle">
                  {{
                    this.getUser.fullName
                      .split(' ')
                      .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
                      .join('')
                  }}
                </div>
                <div class="profile-menu-name">
                  {{ this.getUser.fullName }}
                  <font-awesome-icon
                    icon="fa-solid fa-chevron-right"
                    :class="`chevron ${isOpen ? 'rotated' : ''} chevron-default`"
                  />
                </div>
              </b-row>
              <div
                v-show="isOpen"
                v-closable="{
                  exclude: ['button'],
                  handler: 'onClose'
                }"
                class="profile-menu-list"
              >
                <b-nav-item @click="navigateTo('/profile')" v-show="isAuthenticated" class="menu-row">
                  <div class="d-flex align-items-center profile-menu-item">
                    <font-awesome-icon icon="fa-solid fa-user " class="icon mx-3" />
                    Profilom
                  </div>
                </b-nav-item>
                <b-nav-item @click="navigateTo('/favourites')" v-show="isAuthenticated" class=" menu-row">
                  <div class="d-flex align-items-center profile-menu-item">
                    <font-awesome-icon icon="fa-solid fa-heart" class="icon mx-3" />
                    Kedvencek
                  </div>
                </b-nav-item>
                <b-nav-item
                  @click="navigateTo('/contents')"
                  v-show="isAuthenticated && userHaveReadPermission"
                  class=" menu-row"
                >
                  <div class="d-flex align-items-center profile-menu-item">
                    <font-awesome-icon icon="fa-solid fa-gears" class="icon mx-3" />
                    Admin
                  </div>
                </b-nav-item>
                <b-nav-item v-on:click="handleLogout" @click="toggleOpen" v-show="isAuthenticated" class=" menu-row">
                  <div class="d-flex align-items-center profile-menu-item">
                    <font-awesome-icon icon="fa-solid fa-arrow-right" class="icon mx-3" />
                    Kijelentkezés
                  </div>
                </b-nav-item>
              </div>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar-nav>
      </b-navbar>
    </div>
    <div style=" width: 315px" class="d-none d-xl-flex"></div>

    <b-modal
      ref="login-modal"
      id="login-modal"
      hide-footer
      title="Belépés"
      size="lg"
      modal-class="mt-5"
      dialog-class="mt-5 pt-5"
      content-class="mt-5"
    >
      <div class="d-block">
        <LoginForm modal-form="true" />
      </div>
    </b-modal>
    <b-modal id="voszport-terminated-modal" hide-header hide-footer centered title="" size="xl">
      <div class="d-block mb-5 p-2 pt-0 ">
        <h1 class="d-flex justify-content-center title mb-5"><strong> Sikertelen bejelentkezés!</strong></h1>
        <p class="ml-2 mr-2 d-flex justify-content-center">
          A VOSZPort oldali felhasználó felfüggesztésre került! Ezért a belépés a VOSZPort felületére nem lehetséges.
          Kérjük, vegye fel a kapcsolatot a voszport.hu oldalon az „Írjon nekünk” funkcióval, hogy további segítséget
          nyújthassunk Önnek.
          <br />
          <br />
          Üdvözlettel a VOSZPort csapata!
        </p>
        <div class=" d-flex justify-content-center">
          <b-button class="col-3" @click="closeTerminatedModal">Rendben</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import * as VoszportApi from '../api/voszport'
import LoginForm from '../components/LoginForm.vue'
import handleLogout from '../mixins/HandleLogout'

let handleOutsideClick
Vue.directive('closable', {
  bind(el, binding, vnode) {
    handleOutsideClick = e => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName]
          if (excludedEl !== undefined) {
            clickedOnExcludedEl = excludedEl.contains(e.target)
          }
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind() {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

export default {
  name: 'Navigation',
  mixins: [handleLogout],
  components: {
    LoginForm
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'userHaveReadPermission', 'getUser'])
  },
  data() {
    return {
      whiteNav: true,
      isOpen: false,
      window: {
        width: 0
      }
    }
  },
  methods: {
    handleHomeNav() {
      if (this.isAuthenticated) {
        this.$router.push('/home', () => {})
      } else {
        this.$router.push('/', () => {})
      }
    },
    showLoginModal() {
      this.$refs['login-modal'].show()
    },
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    onClose() {
      this.isOpen = false
    },
    handleResize() {
      this.window.width = window.innerWidth
    },
    navigateTo: function(link) {
      this.$router.push(link)
      this.toggleOpen()
    },
    async goToVoszport() {
      if (this.isAuthenticated) {
        const status = await this.getStatus(this.getUser.email)
        if (status === 'EXIST') {
          const redirectUrl = await this.getLoginRedirectUrl(this.getUser.email)
          window.open(redirectUrl, '_blank')
        }

        if (status === 'NOT_EXIST') {
          const redirectUrl = await this.getRegistRedirectUrl(this.getUser._id)
          window.open(redirectUrl, '_blank')
        }

        if (status === 'SUSPENDED' || status === 'TEMPORALLY_DISABLED') {
          this.openTerminatedModal()
        }

        if (status === 'NO_RESPONSE') {
          window.open('https://voszport.hu', '_blank')
          // errortoast
        }
      } else {
        window.open('https://voszport.hu', '_blank')
      }
    },
    async getStatus(email) {
      try {
        const status = await VoszportApi.getStatus(email)
        return status
      } catch (error) {
        console.log(error)
      }
    },
    async getLoginRedirectUrl(email) {
      try {
        const redirectUrl = await VoszportApi.getLoginRedirectUrl(email)
        return redirectUrl
      } catch (error) {
        console.log(error)
      }
    },
    async getRegistRedirectUrl(userId) {
      try {
        const redirectUrl = await VoszportApi.getRegistRedirectUrl(userId)
        return redirectUrl
      } catch (error) {
        console.log(error)
      }
    },
    openTerminatedModal() {
      this.$root.$emit('bv::show::modal', 'voszport-terminated-modal')
    },
    closeTerminatedModal() {
      this.$root.$emit('bv::hide::modal', 'voszport-terminated-modal')
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
.profile-menu-container {
  position: relative;
  right: -20px;
  width: 200px;
  height: auto;
}

.profile-circle {
  background-color: #cce9d8;
  height: 40px;

  width: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-menu-name {
  margin-left: 10px;
  margin-top: 8px;
}

.profile-menu-list {
  position: absolute;
  z-index: 2000;
  right: -55px;
  top: 75px;
  text-align: left;

  background: #ffffff;
  border: 1px solid #dfe2ea;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 25px rgba(0, 0, 0, 0.07);
  border-radius: 8px;

  width: 250px;
  height: auto;
}
.menu-row:hover {
  background: #cce9d8;
  color: #00903c;
}

.chevron-default {
  position: absolute;
  margin-left: 10px;
  color: #636e72;
  font-size: 20px;
}

.chevron {
  transition: all 0.3s;
}

.chevron.rotated {
  transform: rotate(90deg);
}
.icon {
  width: 16px;
  height: 16px;
}

.header-mff img {
  position: relative;
  left: 0;
  max-height: 114px;
  max-width: 375px;
  object-fit: contain;
}

.header-mff img.second-img {
  max-height: 90px;
  max-width: 300px;
}

.header-mff {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-logo {
  height: 94px;
  display: flex;
  align-items: center;
  margin-left: 0px;
}

.header-container {
  display: flex;
  justify-content: space-between;
  top: 0;
}

@media all and (max-width: 615px) {
  .header-container {
    display: block;
    justify-content: unset;
  }
  .header-mff img {
    max-height: 140px;
    max-width: unset;
  }
}

@media all and (max-width: 490px) {
  .header-mff img {
    max-height: 120px;
  }
}

@media all and (max-width: 430px) {
  .header-mff img {
    max-height: 100px;
  }
}

@media all and (max-width: 1200px) {
  .header-navigation {
    width: 100% !important;
  }
}
</style>
